import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../utils/api';

export default function Payment() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const paymentKey = searchParams.get('key');
  const iframeId = searchParams.get('iframe');
  const entityType = searchParams.get('type');
  const entityId = searchParams.get('id');

  const [polling, setPolling] = useState(false);

  useEffect(() => {
    if (!paymentKey || !iframeId) {
      navigate('/cart', { replace: true });
    }
  }, [paymentKey, iframeId, navigate]);

  // Poll payment status while iFrame is active
  useEffect(() => {
    if (!entityType || !entityId) return;

    setPolling(true);
    const interval = setInterval(async () => {
      try {
        const data = await api.getPaymentStatus(entityType, parseInt(entityId, 10));
        if (data.status === 'paid') {
          clearInterval(interval);
          setPolling(false);
          navigate(`/payment-result?success=true&type=${entityType}&id=${entityId}`, { replace: true });
        }
      } catch {
        // Ignore polling errors
      }
    }, 5000);

    return () => {
      clearInterval(interval);
      setPolling(false);
    };
  }, [entityType, entityId, navigate]);

  if (!paymentKey || !iframeId) return null;

  const iframeSrc = `https://accept.paymob.com/api/acceptance/iframes/${iframeId}?payment_token=${paymentKey}`;

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-base)',
      color: 'var(--text-primary)',
      fontFamily: 'var(--font-body)',
      padding: '5rem 1rem 3rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '720px',
        margin: '0 auto',
      }}>
        <h1 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '1.5rem',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          marginBottom: '0.5rem',
          textAlign: 'center',
        }}>
          {t('payment.title')}
        </h1>

        <p style={{
          textAlign: 'center',
          color: 'var(--text-muted)',
          fontSize: '0.9rem',
          marginBottom: '1.5rem',
        }}>
          {t('payment.secureNotice')}
        </p>

        <div style={{
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-md)',
          overflow: 'hidden',
          boxShadow: 'var(--shadow-card)',
        }}>
          <iframe
            src={iframeSrc}
            title="Paymob Payment"
            style={{
              width: '100%',
              height: '600px',
              border: 'none',
              display: 'block',
            }}
          />
        </div>

        {polling && (
          <p style={{
            textAlign: 'center',
            color: 'var(--text-muted)',
            fontSize: '0.85rem',
            marginTop: '1rem',
          }}>
            {t('payment.waitingConfirmation')}
          </p>
        )}

        <div style={{
          textAlign: 'center',
          marginTop: '1.5rem',
        }}>
          <button
            type="button"
            onClick={() => navigate('/cart')}
            style={{
              padding: '0.5rem 1.5rem',
              background: 'transparent',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius-sm)',
              color: 'var(--text-muted)',
              fontFamily: 'var(--font-heading)',
              fontSize: '0.8rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            {t('payment.cancelAndReturn')}
          </button>
        </div>
      </div>
    </div>
  );
}
